module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Condensed.12777e2.woff";